export default __webpack_public_path__ + "static/media/escape-day.f3defa38.jpg";